import React, { useContext } from 'react';
import { I18nProvider } from '@fiverr-private/i18n-react';
import { HeaderContext } from '../../modern/context/HeaderContext';

/**
 * withTranslation HOC is responsible for passing the i18n prop in the correct
 * locale context to the given wrapped component.
 *
 * Uses `useContext(HeaderContext)` directly (rather than `useHeaderContext()`) since this
 * HOC is applied broadly (e.g. via `Link`) to components that may render without a
 * `HeaderContext.Provider` ancestor (unit tests in particular); it only needs `locale` and
 * should degrade gracefully instead of throwing when there's no provider.
 *
 * @param WrappedComponent
 * @returns {function(*): *}
 */
const withTranslation = (WrappedComponent) => {
    const TranslationWrapper = (props) => {
        const locale = useContext(HeaderContext)?.locale;

        return <I18nProvider locale={locale}>{({ i18n }) => <WrappedComponent i18n={i18n} {...props} />}</I18nProvider>;
    };

    return TranslationWrapper;
};

export default withTranslation;
